
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Force a full page refresh if HMR fails
if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    console.log('Vite update detected, refreshing page...');
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(<App />);
